import type { VoidFunctionComponent, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { Icon, icons } from '../../generic';
import styles from './IssueContent.module.less';

type ResolvedReasonProps = {
  resolvedAtMessage: string;
  notes: ReactNode;
};

export const ResolvedReason: VoidFunctionComponent<ResolvedReasonProps> = ({ resolvedAtMessage, notes }) => {
  return (
    <div className={`panel panel-flat panel-success ${styles.resolvedReason}`}>
      <div className="panel-heading-light">
        <Icon icon={icons.circleO} /> {resolvedAtMessage}
      </div>
      <div className="padded">{notes}</div>
    </div>
  );
};
/**
 * IssueDetailsResolvedReason displays the ignored information
 * of the vulnerability currently being viewed.
 */
const IssueDetailsResolvedReason = () => {
  const isIssueResolved = useSelector(IssuesV2Store.selectors.getIsIssueResolved);
  const resolvedMessage = useSelector(IssuesV2Store.selectors.getIgnoredMessage);
  const resolutionReason = useSelector(IssuesV2Store.selectors.getResolutionReason);
  const resolutionNotes = useSelector(IssuesV2Store.selectors.getResolutionNotes);
  if (!resolvedMessage || !isIssueResolved) {
    return null;
  }

  return (
    <ResolvedReason
      resolvedAtMessage={resolvedMessage}
      notes={
        <>
          {resolutionReason}
          <span className="italic">{resolutionNotes}</span>
        </>
      }
    />
  );
};

export default IssueDetailsResolvedReason;
